//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IDraftPost } from '@apis/universal-posts/draft-posts/universalDraftPostsApiModel';

export enum INSTAGRAM_DRAFTS_MODAL_ACTIONS {
  OPEN_DELETE_DRAFT_MODAL = 'INSTAGRAM_DRAFTS_MODAL_ACTIONS/OPEN_DELETE_DRAFT_MODAL',
  CLOSE_DELETE_DRAFT_MODAL = 'INSTAGRAM_DRAFTS_MODAL_ACTIONS/CLOSE_DELETE_DRAFT_MODAL',
}

export interface IInstagramDraftsModalState {
  isDeleteDraftModalOpen: boolean;
  currentDraft?: IDraftPost;
}
